import { Injectable } from '@angular/core';
import { CommonService } from './common.service';
import { PostProcessHttpResponseCurrencyService } from './post-process-http-response-currency.service';

@Injectable({
  providedIn: 'root'
})
export class PostProcessHttpResponseService {
  dontReplaceLogoPath = false;

  constructor(
    private postProcessRespForCurrency: PostProcessHttpResponseCurrencyService,
    private commonService : CommonService
  ) { }
  private responseMatchPattern: any = ['data.sellerConfig'];

  private urlRespPatternConfig = {
    'getInv': {
      fn: (resp) => {
        //Process for Currency
        if (resp.data && resp.data.invoices) {
          Object.keys(resp.data.invoices).forEach(invKey => {
            const inv = resp.data.invoices[invKey];
            this.postProcessRespForCurrency.processInvoice(inv);
          })
        }
        //Process for logo
        // if (resp.data && resp.data.sellerConfig) {
        //   Object.keys(resp.data.sellerConfig).forEach(key => {
        //     resp.data.sellerConfig[key].sellerImg = `${this.commonService.getInterfaceUrl('GET_LOGO')}`
        //   });
        // }
      }
    },
    'paymentCreditNotes': {
      fn: (resp) => {
        //Process for Currency
        if (resp.data && resp.data.creditNotes) {
          Object.keys(resp.data.creditNotes).forEach(key => {
            const creditNote = resp.data.creditNotes[key];
            this.postProcessRespForCurrency.processPaymentCreditNotes(creditNote);
          })
        }
      }
    },
    'payments': {
      fn: (resp) => {
        //Process for Currency
        if (resp.data && resp.data.transactions) {
          Object.keys(resp.data.transactions).forEach(transKey => {
            const trans = resp.data.transactions[transKey];
            this.postProcessRespForCurrency.processPayment(trans);
          })
        }
      }
    },
    'paymentDetails': {
      fn: (resp) => {
        //Process for Currency
        if (resp.data && resp.data) {
          this.postProcessRespForCurrency.processPaymentDetails(resp.data);
          // Object.keys(resp.data.transactions).forEach(transKey => {
          //   const trans = resp.data.transactions[transKey];
          // })
        }
      }
    },
    // 'listEligibleCashDiscount': {
    //   fn: (resp) => {
    //     //Process for Currency
    //     if (resp.data && resp.data.invoice) {
    //       Object.keys(resp.data.invoice).forEach(key => {
    //         const creditNote = resp.data.invoice[key];
    //         this.postProcessRespForCurrency.processPaymentCreditNotes(creditNote);
    //       })
    //     }
    //   }
    // },
    'creditNotes': {
      fn: (resp) => {
        //Process for Currency
        if (resp.data && resp.data.creditNotes) {
          Object.keys(resp.data.creditNotes).forEach(key => {
            const creditNote = resp.data.creditNotes[key];
            console.log('cn......');
            console.log(creditNote);
            
            
            this.postProcessRespForCurrency.processCreditNotes(creditNote);
          })
        }      }
    },
    'getInvoicesForPayment': {
      fn: (resp) => {
        //Process for Currency
        if (resp.data && resp.data.invoices) {
          Object.keys(resp.data.invoices).forEach(invKey => {
            const inv = resp.data.invoices[invKey];
            this.postProcessRespForCurrency.processInvoicesForPayment(inv);
          })
        }
      }
    },
    
  }

  processResponse(url, resp) {
    const splitUrl = url.split('/');
    const urlEndPoint = splitUrl[splitUrl.length - 1]
    if (this.urlRespPatternConfig[urlEndPoint] && this.urlRespPatternConfig[urlEndPoint].fn) {
      this.urlRespPatternConfig[urlEndPoint].fn(resp);
    }
    this.postProcessSellerConfig(resp);
    this.postProcessGenericResponse(resp);
  }

  private postProcessGenericResponse(response) {
    this.responseMatchPattern.forEach(dataPath => {
      let currentObj = response;
      dataPath.split('.').forEach(dataKey => {
        if (currentObj) {
          currentObj = currentObj[dataKey];
        }
      });
      if (currentObj) {
        Object.keys(currentObj).forEach(key => {
          const dataObj = currentObj[key];
          if ((!dataObj.sellerImg || dataObj.sellerImg.indexOf('http') === -1) && dataObj.sellerNm) {
            dataObj.sellerImg = `/assets/offline/${dataObj.sellerNm}.png`;
          }
        });
      }
    });
  }

  private postProcessSellerConfig(responseData) {
    console.log(responseData);
    
    let currentObj = responseData?.data?.sellerConfig || {};
    if (!this.dontReplaceLogoPath && currentObj) {
      Object.keys(currentObj).forEach(key => {
        const dataObj = currentObj[key];
        console.log(dataObj);
        
        if (dataObj && dataObj.sellerNm) {
          if (this.checkHTTP(dataObj.sellerImg)){
            // dataObj.sellerImg = `http://localhost:8090/auth/image1`
            dataObj.sellerImg = `${this.commonService.getInterfaceUrl('GET_LOGO')}/${dataObj.sellerNm}`;
            console.log('dataObj.sellerImg : ', dataObj.sellerImg);
            console.log('this.commonService.getInterfaceUrl(GET_LOGO) : ', this.commonService.getInterfaceUrl('GET_LOGO'));
            
          }
           
        }
      });
    }
  }

   checkHTTP(string) {
    if(/(http(s?)):\/\//i.test(string)) {
      console.log("valif");
      
      return true
    }
    return false
  }


}
